import React from 'react';
import { disciplines } from '../data/hero';
import { phases, tools } from '../data/system';
export function SystemOverview() {
  return <section aria-label="Resumen del sistema" className="bg-navy text-white" data-id="element-275" data-mp="18v0mymbbl32b">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "22px"
    }} data-id="element-276" data-mp="1mlcgmpnjz9vk">
        <div className="mx-auto max-w-3xl text-center" data-id="element-277" data-mp="1ho45va4qi84c">
          <h2 className="font-display text-3xl font-extrabold uppercase leading-none sm:text-5xl" data-id="element-278" data-mp="txgnfux7003j">
            Sistema Triatlón Completo™ · 5 en 1
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-279" data-mp="pyhiiabgo3c3">
            El sistema completo para deportistas que no quieren organizar su preparación a partir de
            entrenamientos aislados, consejos desconectados y recursos dispersos.
          </p>
          <p className="mt-5 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-280" data-mp="2f9rwfeeidw7y">
            {disciplines.map((d, i) => <React.Fragment key={d} data-id="element-281" data-mp="235cjlw71k2so" data-mpi={i}>
                {i > 0 && <span className="text-aqua" aria-hidden="true" data-id="element-282" data-mp="238qmr6nj4g16">·</span>}
                <span data-id="element-283" data-mp="283md82d4avc6">{d}</span>
              </React.Fragment>)}
          </p>
          <p className="mt-3 text-sm text-white/50" data-id="element-284" data-mp="2d5le95ldxg5y">Todo lo que necesitas en un combo integral 5 en 1</p>
        </div>

        <p className="mt-12 text-center text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-285" data-mp="2i34xkjwxwj4r">
          Un sistema · Seis fases · Cuatro herramientas complementarias
        </p>

        <ol className="relative mt-8 grid gap-5 lg:grid-cols-6 lg:gap-4" data-id="element-286" data-mp="1pfr4wy09y9qg">
          <span aria-hidden="true" className="absolute bottom-3 left-[17px] top-3 w-px bg-electric/50 lg:bottom-auto lg:left-[18px] lg:right-[18px] lg:top-[17px] lg:h-px lg:w-auto" data-id="element-287" data-mp="1udizjzsb09yc" />
          {phases.map((p, i) => <li key={p.n} className="relative flex items-start gap-4 text-left lg:flex-col lg:gap-3" data-id="element-288" data-mp="11q6k09kk92ej" data-mpi={i}>
              <span className={i === phases.length - 1 ? 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-electric font-display text-sm font-bold text-white' : 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-electric bg-navy font-display text-sm font-bold text-white'} data-id="element-289" data-mp="16nonvljq0rfo">
                {p.n}
              </span>
              <div data-id="element-290" data-mp="13dyyaal1u5j4">
                <p className="font-display text-lg font-bold uppercase leading-tight" data-id="element-291" data-mp="13fjsfz3gbmgg">{p.name}</p>
                <p className="mt-0.5 text-sm leading-snug text-white/60" data-id="element-292" data-mp="fpz8pdzh4l64">{p.short}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12 border-t border-white/10 pt-8" data-id="element-293" data-mp="arnyh259o8nd">
          <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-white/50" data-id="element-294" data-mp="po59ttdghn9x">
            Además, 4 herramientas complementarias
          </p>
          <ul className="mt-6 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-295" data-mp="21290oqoqyvar">
            {tools.map(({
            verb,
            name,
            desc,
            icon: Icon
          }) => <li key={verb} className="flex items-start gap-3" data-id="element-296" data-mp="1w5acspvofkl0">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-aqua" aria-hidden="true" data-id="element-297" data-mp="23lxduh9gwzqs" />
                <div data-id="element-298" data-mp="28mtdgimsdzqe">
                  <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-aqua" data-id="element-299" data-mp="28ncuzy8iym3w">{verb}</p>
                  <p className="mt-1 font-display text-base font-bold uppercase leading-tight text-white" data-id="element-300" data-mp="1untr5hmqxwxe">{name}</p>
                  <p className="mt-1 text-xs leading-snug text-white/60" data-id="element-301" data-mp="1ypfbfo1m1dhm">{desc}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}